var _circle, _circle2, _rect, _circle3, _circle4, _circle5, _rect2, _text, _rect3, _text2, _rect4, _text3, _rect5, _text4, _rect6, _text5, _rect7, _polygon, _rect8, _text6, _rect9, _rect0, _rect1, _circle6, _text7, _circle7, _text8, _circle8, _text9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideUseInstantsaver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 420,
    viewBox: "0 0 600 420",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 40,
    r: 90,
    fill: "#eef2ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 390,
    r: 100,
    fill: "#e0eafc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 30,
    width: 480,
    height: 360,
    rx: 18,
    fill: "#ffffff",
    stroke: "#e5e7eb",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 54,
    r: 5,
    fill: "#fca5a5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 54,
    r: 5,
    fill: "#fde68a"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 54,
    r: 5,
    fill: "#bbf7d0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 46,
    width: 22,
    height: 22,
    rx: 6,
    fill: "#4f46e5"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 298,
    y: 63,
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 700,
    fill: "#111827"
  }, "InstantSaver")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 84,
    width: 72,
    height: 26,
    rx: 13,
    fill: "#4f46e5"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 101,
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600,
    fill: "#fff",
    textAnchor: "middle"
  }, "Instagram")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 84,
    width: 64,
    height: 26,
    rx: 13,
    fill: "#ffffff",
    stroke: "#e5e7eb"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 332,
    y: 101,
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600,
    fill: "#374151",
    textAnchor: "middle"
  }, "YouTube")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 130,
    width: 300,
    height: 40,
    rx: 12,
    fill: "#ffffff",
    stroke: "#c7d2fe",
    strokeWidth: 2
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 106,
    y: 155,
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fill: "#9ca3af"
  }, "Paste Instagram link here\u2026")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 130,
    width: 90,
    height: 40,
    rx: 12,
    fill: "#2563eb"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 445,
    y: 155,
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    fill: "#fff",
    textAnchor: "middle"
  }, "Preview")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 196,
    width: 150,
    height: 150,
    rx: 12,
    fill: "#eef1f8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "150,255 150,290 182,272",
    fill: "#c7d2fe"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 356,
    width: 130,
    height: 34,
    rx: 10,
    fill: "#15803d"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 165,
    y: 378,
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    fill: "#fff",
    textAnchor: "middle"
  }, "Download")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 200,
    width: 230,
    height: 10,
    rx: 5,
    fill: "#e5e7eb"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 218,
    width: 180,
    height: 10,
    rx: 5,
    fill: "#e5e7eb"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 236,
    width: 200,
    height: 10,
    rx: 5,
    fill: "#e5e7eb"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 130,
    r: 17,
    fill: "#4f46e5"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 135,
    fontFamily: "system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 700,
    fill: "#fff",
    textAnchor: "middle"
  }, "1")), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 130,
    r: 17,
    fill: "#2563eb"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 494,
    y: 135,
    fontFamily: "system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 700,
    fill: "#fff",
    textAnchor: "middle"
  }, "2")), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 392,
    r: 17,
    fill: "#15803d"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 397,
    fontFamily: "system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 700,
    fill: "#fff",
    textAnchor: "middle"
  }, "3")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideUseInstantsaver);
export default __webpack_public_path__ + "static/media/guide-use-instantsaver.1ae2ed75b7db72b5ab04ff2863bd4d9f.svg";
export { ForwardRef as ReactComponent };